<template>
    <v-dialog v-model="visible" max-width="500" @click:outside="chiudi" @keydown.esc="chiudi">
        <v-card>
            <v-card-title>Ricollega Garmin</v-card-title>
            <v-card-text>
                <p>
                    Garmin sta dismettendo il vecchio sistema di collegamento usato dal tuo account.
                </p>
                <p>
                    Per continuare a ricevere le attività e a inviare gli allenamenti su Garmin
                    <strong>ricollega l'account</strong>: bastano pochi secondi.
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="chiudi">Più tardi</v-btn>
                <v-btn color="primary" text @click="ricollega">Ricollega ora</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from '@mixins/api.js';

const endpoint = `${process.env.VUE_APP_API_BASE_URL}/api/v2/connection.php?provider=garmin`;

// Invito agli atleti ancora collegati a Garmin con OAuth1 a rifare l'autorizzazione con OAuth2
// prima della dismissione di OAuth1. Si apre su data.invito di connection.php, calcolato dal
// server (reauth && costante PHP GARMIN_INVITO_RICOLLEGAMENTO in constants.php): la costante
// non e' letta qui, si accende e spegne solo lato server. "Più tardi" lo ripropone dopo
// RIPROPOSTA_MS; l'istante di chiusura e' in localStorage, cosi' vale anche riaprendo l'app.
const RIPROPOSTA_MS = 24 * 60 * 60 * 1000;
const STORAGE_KEY = 'ricollegaGarminChiuso';
const ROUTE_CONNESSIONI = 'connessioni';

function leggiChiusura() {
    try {
        return Number(localStorage.getItem(STORAGE_KEY)) || 0;
    } catch (e) {
        return 0;
    }
}

function scriviChiusura(ts) {
    try {
        localStorage.setItem(STORAGE_KEY, String(ts));
    } catch (e) {
        // storage non disponibile: verra' riproposto alla prossima apertura dell'app
    }
}

export default {
    name: 'MspRicollegaGarmin',
    data() {
        return {
            visible: false,
            timer: null,
        };
    },
    mounted() {
        this.programma(Math.max(0, leggiChiusura() + RIPROPOSTA_MS - Date.now()));
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        programma(ritardo) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.load(), ritardo);
        },
        async load() {
            // Nella pagina delle connessioni lo stato "Da ricollegare" e' gia' visibile.
            if (this.visible || this.$route.name === ROUTE_CONNESSIONI) return;
            const result = await api(endpoint, 'GET');
            if (!result || !result.success || !result.data || !result.data.invito) return;
            this.visible = true;
        },
        chiudi() {
            this.visible = false;
            scriviChiusura(Date.now());
            this.programma(RIPROPOSTA_MS);
        },
        ricollega() {
            this.chiudi();
            this.$router.push({ name: ROUTE_CONNESSIONI });
        },
    },
};
</script>
